import React, { useState, useEffect } from 'react'
import Question_ from "../assets/Question.png";
import MultiChoices from './MultiChoices';
import OpenEndedQuestion from './OpenEndedQuestion';
import multi_choices from "../assets/multi_choices.jpg";
import EquationEditor from "./TextArea"
import axios from 'axios';
import Swal from 'sweetalert2'
import { BASE_URL, QuestionTypes } from "../constants";
import { IoIosOptions } from "react-icons/io";
import { MdDelete } from "react-icons/md";
import { useSelector } from 'react-redux';
import { handleInisStudentSelfLearningMode } from './InteractiveVideo';

function answerSearch(qoption, answerQoptionsIds) {
  const qoptionId = qoption.optionId;
  const x = (answerQoptionsIds?.indexOf(qoptionId)) ?? (-1);
  const flag = x !== -1;
  return flag;
}

const reform_question_options = (question_options) => {
  // console.log("question_options");
  // console.log(question_options);
  return question_options.map((option) => ({ ...option, istrue: false })).sort((a, b) => (a.optionId - b.optionId));
}

export default function ViewQuestion({
  videoRef,
  questions,
  setQuestions,
  setHitQuestion,
  question,
  isPlaying,
  setIsPlaying,
  setFullStyle,
  interactiveMode,
  isStudentSelfLearningMode,
  questionStylesInisStudentSelfLearningMode,
  setQuestionStylesInisStudentSelfLearningMode
}) {
  const student_id = useSelector(state => state.user.details.userId);

  const [isCheckboxValid, setIsCheckboxValid] = useState(true);
  const [editEnabled, setEditEnabled] = useState(false);
  const [editSave, setEditSave] = useState(false);
  const [allOptions, setAllOptions] = useState(reform_question_options(question.options));
  const [answerBody, setAnswerBody] = useState("");
  const video = videoRef.current;



  // ==============================================================

  const [handleFormSubmit_flag, setHandleFormSubmit_flag] = useState(true);
  const [is_student_answer_correct, setIs_student_answer_correct] = useState(false);
  const [remaining_num_of_tries, setRemaining_num_of_tries] = useState(1);
  const [explanation, setExplanation] = useState(null);
  const [the_correct_answer, setThe_correct_answer] = useState(null);
  const [answerQoptionsIds, setAnswerQoptionsIds] = useState("")

  useEffect(() => {
    if (isStudentSelfLearningMode) {
      const question_id = question?.id;
      let is_student_answer_correct_tmp = false;
      let handleFormSubmit_flag_tmp = true;
      let remaining_num_of_tries_tmp = 1;
      let the_correct_answer_tmp = null;
      let explanation_tmp = null;
      let answerQoptionsIds_tmp = null;
      if (questionStylesInisStudentSelfLearningMode.hasOwnProperty(question_id)) {
        explanation_tmp = questionStylesInisStudentSelfLearningMode[question_id].explanation ?? null;
        the_correct_answer_tmp = questionStylesInisStudentSelfLearningMode[question_id].the_correct_answer ?? "";
        is_student_answer_correct_tmp = questionStylesInisStudentSelfLearningMode[question_id].is_student_answer_correct ?? false;
        remaining_num_of_tries_tmp = questionStylesInisStudentSelfLearningMode[question_id].remaining_num_of_tries ?? 1;
        if (is_student_answer_correct_tmp || (!remaining_num_of_tries_tmp)) {
          handleFormSubmit_flag_tmp = false;
          if (question?.type == QuestionTypes?.multiChoices) {
            answerQoptionsIds_tmp = the_correct_answer_tmp?.split('|');
          }
        }
      }
      setHandleFormSubmit_flag(handleFormSubmit_flag_tmp);
      setExplanation(explanation_tmp);
      setAnswerQoptionsIds(answerQoptionsIds_tmp);
      setIs_student_answer_correct(is_student_answer_correct_tmp);
      setRemaining_num_of_tries(remaining_num_of_tries_tmp);
      setThe_correct_answer(the_correct_answer_tmp);
    }

  }, [isStudentSelfLearningMode, questionStylesInisStudentSelfLearningMode, question])


  // ==============================================================



  const sweetAlert = ({ title, text, icon }) => {
    return Swal.fire({
      title: `${title}`,
      text: `${text}`,
      icon: `${icon}`
    });
  }

  const handleCheckboxChange = (event, id) => {
    const isChecked = event.target.checked;

    if (isChecked) {
      setAllOptions((options) => options.map(option => option.optionId == id ? { ...option, istrue: true } : option))
      setIsCheckboxValid(true);

    } else {

      setAllOptions((options) => options.map(option => option.optionId == id ? { ...option, istrue: false } : option));
    }
  };

  const handleSkipTheQuestion = () => {
    setHitQuestion(false);
    setTimeout(() => {
      const video = videoRef.current;
      setIsPlaying(!isPlaying);

      video.id == "video" && video.play();
    }, 10)
  }

  const handleDeleteQuestion = () => {
    const video = videoRef.current;
    video.id == "video" && video.pause();
    setIsPlaying(false);

    Swal.fire({
      title: `Are you sure want to delete that question `,
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Yes',
      denyButtonText: 'No',
      customClass: {
        actions: 'my-actions',
        cancelButton: 'order-1 right-gap',
        confirmButton: 'order-2',
        denyButton: 'order-3',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        axios.delete(`${BASE_URL}/lesson/deleteQuestion.php?questionId=${question.id}`).then((res) => {
          sweetAlert({ title: "Deleted Succefully", text: "", icon: "info" });
          handleSkipTheQuestion();
        })
        setQuestions((prevQuetions) => prevQuetions.filter(q => q.id !== question.id))
      }
    })
  }

  const handleEditTheQuestion = () => {
    setEditEnabled(true);

    const video = videoRef.current;
    video.id == 'video' && video.pause();
    setIsPlaying(false);
  }

  const formatResponse = () => {
    const selectedOptions = allOptions.map((option) => option.istrue ? option.optionId : false).filter((option) => option !== false)
    const formattedResponse = {
      student_id: student_id,
      answer: question.type == QuestionTypes.multiChoices ? selectedOptions.join('|') : answerBody
    }
    return formattedResponse;
  }


  const handleFormSubmit = (event) => {
    const selectedOptions = allOptions.map((option) => option.istrue ? option.optionId : false).filter((option) => option !== false)

    event.preventDefault();

    if (!selectedOptions.length && question.type == QuestionTypes.multiChoices) {
      setIsCheckboxValid(false);
      return;
    }
    if (answerBody == '' && question.type == QuestionTypes.essay) {
      setIsCheckboxValid(false);
      return;
    }
    const formattedResponse = formatResponse();

    // console.log("isStudentSelfLearningMode");
    // console.log(isStudentSelfLearningMode);
    let hasFailed = true;
    if (isStudentSelfLearningMode) {
      Swal.showLoading();
      const question_id = question?.id;
      axios.put(`${BASE_URL}/lesson/answerInStudentSelfLearningMode.php`, {
        ...formattedResponse,
        question_id,
      }).then((response) => {
        const response_data_data = response?.data?.data;
        let x = {};
        if (response_data_data) {
          const questionAnswer = response_data_data?.answer;
          if (questionAnswer) {
            hasFailed = false;
            if (question.type == QuestionTypes.multiChoices) {
              setAllOptions(reform_question_options(question.options).map(element => (questionAnswer.split('|').includes(`${element.optionId}`) ? { ...element, istrue: true } : element)));
            } else {
              setAnswerBody(questionAnswer)
            }
          }
          x = handleInisStudentSelfLearningMode([{ ...response_data_data, question_id }] ?? [], questionStylesInisStudentSelfLearningMode ?? {});
          if (x) {
            // is_student_answer_correct = x[question_id]?.is_student_answer_correct;
            const remaining_num_of_tries = x[question_id]?.remaining_num_of_tries;
            const flagRethink = x[question_id]?.flagRethink;
            if (flagRethink) {
              sweetAlert({ title: "Rethink about it", text: `You still got ${remaining_num_of_tries} more tr${(1 < remaining_num_of_tries) ? "ies" : "y"}.`, icon: "error" });
            } else {
              // explanation = x[question_id]?.explanation;
              // the_correct_answer = x[question_id]?.the_correct_answer;
              Swal.close()
            }
          }
        } else {
          x = { ...questionStylesInisStudentSelfLearningMode };
          if (x.hasOwnProperty(question_id)) {
            delete x[question_id];
          }
        }
        setQuestionStylesInisStudentSelfLearningMode(x);
        if (hasFailed && (question.type == QuestionTypes.multiChoices)) {
          setAllOptions(reform_question_options(question.options));
        }
      })
        .catch(e => {
          if (hasFailed && (question.type == QuestionTypes.multiChoices)) {
            setAllOptions(reform_question_options(question.options));
          }
          sweetAlert({ title: "Sorry!", text: e?.response?.data?.msg ?? "Error happend", icon: "error" }).then(() => {
            handleSkipTheQuestion();
          });
        })
    } else {
      handleSkipTheQuestion();
      if (editSave) {
        // console.log("edit");
        axios.put(`${BASE_URL}/lesson/updateAnswer.php?questionId=${question.id}`, formattedResponse).then((res) => {
          sweetAlert({ title: "Your answer is submitted!", text: "", icon: "info" });
        })
      } else {
        axios.post(`${BASE_URL}/lesson/addAnswer.php?questionId=${question.id}`, formattedResponse).then((res) => {
          sweetAlert({ title: "Your answer is submitted!", text: "", icon: "info" });
        })
      }
    }
    // handleSkipTheQuestion();
    // setTimeout(() => {
    //   const video = videoRef.current;
    //   setIsPlaying(!isPlaying);

    //   video.id == "video" && video.play();
    // }, 10)
    return;
  };


  useEffect(() => {
    const question_id = question?.id;
    const fetchData = async () => {
      let hasFailed = true;
      try {
        if (isStudentSelfLearningMode) {
          Swal.showLoading();
          axios.get(`${BASE_URL}/lesson/questionAnswerInStudentSelfLearningMode.php?questionIds=${question_id}&student_id=${student_id}`).then((response) => {
            Swal.close()
            const response_data_data = response?.data?.data;
            let x = {};
            if (response_data_data?.length) {
              const questionAnswer = response_data_data[0]?.answer;
              if (questionAnswer) {
                hasFailed = false;
                if (question.type == QuestionTypes.multiChoices) {
                  setAllOptions(reform_question_options(question.options).map(element => (questionAnswer.split('|').includes(`${element.optionId}`) ? { ...element, istrue: true } : element)));
                } else {
                  setAnswerBody(questionAnswer)
                }
              }
              x = handleInisStudentSelfLearningMode(response_data_data ?? [], questionStylesInisStudentSelfLearningMode ?? {});
            } else {
              x = { ...questionStylesInisStudentSelfLearningMode };
              if (x.hasOwnProperty(question_id)) {
                delete x[question_id];
              }
            }
            setQuestionStylesInisStudentSelfLearningMode(x);
            if (hasFailed && (question.type == QuestionTypes.multiChoices)) {
              setAllOptions(reform_question_options(question.options));
            }
          }).catch(e => {
            // console.log("e");
            // console.log(e);

            if (hasFailed && (question.type == QuestionTypes.multiChoices)) {
              setAllOptions(reform_question_options(question.options));
            }
            sweetAlert({ title: "Sorry!", text: e?.response?.data?.msg ?? "Error happend", icon: "error" }).then(() => {
              handleSkipTheQuestion();
            });
          })
        } else {
          const response = await axios.get(`${BASE_URL}/lesson/questionAnswer.php?&questionId=${question.id}&student_id=${student_id}`);
          const questionAnswer = response.data.answer;
          if (questionAnswer) {
            setEditSave(true)
            if (question.type == QuestionTypes.multiChoices) {
              hasFailed = false;
              setAllOptions(reform_question_options(question.options).map(element => (questionAnswer.split('|').includes(`${element.optionId}`) ? { ...element, istrue: true } : element)));
            } else {
              setAnswerBody(questionAnswer)
            }
          }
          if (hasFailed) {
            setAllOptions(reform_question_options(question.options));
          }
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [question.id]);

  return (
    <div >
      <form
        onSubmit={(e) => {
          if (handleFormSubmit_flag) {
            handleFormSubmit(e);
          }
        }}
        className="question-overlay"
      >
        <div className="flex items-center font-semibold text-lg gap-2">
          <img src={question.type == QuestionTypes.multiChoices ? multi_choices : Question_} alt="Icon" />
          <p className='m-0'> {question.type == QuestionTypes.multiChoices ? "Multi Choices Question" : "Open Ended Question"} </p>
        </div>

        {
          handleFormSubmit_flag ? null : (
            is_student_answer_correct ?
              (
                <div
                  style={{
                    color: "green",
                    fontSize: "40px",
                  }}
                >
                  You passed this question Successfully.
                </div>
              )
              :
              (
                remaining_num_of_tries ? null : (
                  <div
                    style={{
                      color: "red",
                      fontSize: "40px",
                    }}
                  >
                    Sorry, you can't retry this question.
                  </div>
                )
              )
          )
        }
        <div className='flex flex-col w-full gap-4'>
          <h1 className='m-0'>{question.questionBody}</h1>

          {
            question.type == QuestionTypes.multiChoices &&
            <div className="flex flex-col gap-1">
              {
                allOptions.map((option, idx) => (
                  <div key={idx} className='font-semibold text-2xl'>
                    {
                      interactiveMode ?
                        <div className='flex items-center gap-2'>
                          <IoIosOptions />
                          <p className='m-0'> {option.value}</p>
                        </div>
                        :
                        <div className='flex gap-2 items-center cursor-pointer'>
                          <input
                            disabled={!handleFormSubmit_flag}
                            checked={option.istrue}
                            type="checkbox" className=" w-6 h-6 cursor-pointer" id={`${option.optionId}`}
                            onChange={(event) => handleCheckboxChange(event, option.optionId)}
                            value={option.value}
                            name='answer'
                          />
                          <label htmlFor={`${option.optionId}`} className='m-0 cursor-pointer'> {
                            answerSearch(option, answerQoptionsIds) ?
                              <span
                                style={{
                                  color: "green"
                                }}
                              >{option.value}</span>
                              :
                              handleFormSubmit_flag ? option.value :
                                <span
                                  style={{
                                    color: "red"
                                  }}
                                >{option.value}</span>
                          }</label>
                        </div>
                    }
                  </div>
                ))
              }

              {!isCheckboxValid && (
                <div className="text-danger">{question.type == QuestionTypes.multiChoices ? "Please select at least one checkbox." : "Please enter your answer"}</div>
              )}
            </div>
          }

          {
            !interactiveMode && question.type == QuestionTypes.essay &&
            <EquationEditor
              disabled={!handleFormSubmit_flag}
              placeholder={"Enter your answer here."}
              questionBody={answerBody}
              setQuestionBody={setAnswerBody}
            />
          }
        </div>

        {
          (explanation && (!handleFormSubmit_flag) && (is_student_answer_correct || (!remaining_num_of_tries))) ?
            <div>
              <div
                style={{
                  // color: "green",
                  fontSize: "22px",
                }}
              >
                the correct answer:
              </div>
              <div
                style={{
                  color: "green",
                  fontSize: "20px",
                }}
              >
                {
                  (question.type == QuestionTypes.essay) ? the_correct_answer :
                    (
                      () => {

                        const answerQoptions = allOptions.filter(x => answerSearch(x, answerQoptionsIds));
                        // console.log("allOptions");
                        // console.log(allOptions);
                        return answerQoptions.map(x => (<div key={x.optionId} >{x.value}</div>))
                      }
                    )()
                }
              </div>
              <div
                style={{
                  // color: "green",
                  fontSize: "22px",
                }}
              >
                Explanation:
              </div>
              <div
                style={{
                  // color: "green",
                  fontSize: "17px",
                }}
              >
                {explanation}
              </div>
            </div>
            :
            null
        }

        {
          interactiveMode ?
            <div className={`flex gap-2 justify-end`}>
              <button onClick={handleDeleteQuestion} type="button" className="btn btn-danger"><MdDelete fontSize={20} /></button>
              <button onClick={handleEditTheQuestion} type="button" className="btn btn-primary ">Edit</button>
            </div>
            :
            <div className={`flex gap-2 justify-end`}>
              <button
                disabled={!handleFormSubmit_flag}
                onClick={(event) => {
                  if (handleFormSubmit_flag) {
                    handleFormSubmit(event)
                  }
                }}
                type="submit"
                className="btn btn-primary"
              >
                Submit
              </button>
            </div>
        }

      </form>
      {editEnabled && question.type == QuestionTypes.multiChoices &&
        <MultiChoices
          setQuestions={setQuestions}
          questions={questions}
          setIsPlaying={setIsPlaying}
          setFullStyle={setFullStyle}
          setHitQuestion={setHitQuestion}
          videoRef={videoRef}
          currentTimeInSec={video.id == 'video' ? video.currentTime : video.getCurrentTime()}
          editMode={editEnabled}
          setIsMutiChoicesVisiable={setEditEnabled}
          isMutiChoicesVisiable={editEnabled}
          question={question}
        />}

      {editEnabled && question.type == QuestionTypes.essay &&
        <OpenEndedQuestion
          setQuestions={setQuestions} questions={questions}
          setIsPlaying={setIsPlaying}
          setFullStyle={setFullStyle}
          setHitQuestion={setHitQuestion}
          videoRef={videoRef} currentTimeInSec={video.id == 'video' ? video.currentTime : video.getCurrentTime()}
          editMode={editEnabled}
          setIsOpenEndedQuestionVisiable={setEditEnabled}
          isOpenEndedQuestionVisiable={editEnabled}
          question={question}
        />}
    </div>
  )

}
